import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { Button } from 'antd';
import { DeconstructedURL } from '@sonar-software/sonar-ts-lib';
import { LocalStorageKey } from '@sonar-software/sonar-ts-types';
import { FULL_ROUTES, SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useMemo } from 'react';
import { useAmplitude, useAuthToken, useSalesforceAuth } from '@hooks';
function getRedirectState() {
    const { subdomain } = new DeconstructedURL(window.location.href);
    return subdomain;
}
export const LinkSalesforce = () => {
    const log = useAmplitude();
    const { organizationId } = useAuthToken();
    const redirectState = useMemo(getRedirectState, []);
    const { authRedirect } = useSalesforceAuth(FULL_ROUTES.CONFIRM_LINK, redirectState);
    const handleClick = useCallback(() => {
        var _a;
        log(AMPLITUDE_EVENT.NEW_SALESFORCE_ORGANIZATION_CLICKED);
        localStorage.setItem(LocalStorageKey.LastUsedOrg, (_a = organizationId === null || organizationId === void 0 ? void 0 : organizationId.toString()) !== null && _a !== void 0 ? _a : '');
        authRedirect();
    }, [authRedirect, log, organizationId]);
    return (React.createElement(Button, { id: 'link-salesforce-org', onClick: handleClick, type: 'primary' }, SETTINGS_ORGANIZATION_COPY.LINK_NEW_SALESFORCE_ORGANIZATION));
};
